import { RuleSearchChapterContainer } from './RuleSearchChapterContainer';
export default RuleSearchChapterContainer;
